export const RQ_GET_BRAND_SPECILAITY_API = {
  url:'reports/brand/brand_speciality_report/<%= divisionId %>/<%= fromDate %>/<%= toDate %>',
  method:'GET',
  auth:true,
};

export const RQ_GET_MERIND_SPECIALITY_API = {
  url:'reports/brand/product_speciality_report/<%= divisionId %>/<%= fromDate %>/<%= toDate %>',
  method:'GET',
  auth:true,
};

export const RQ_GET_E_DETAILING_API = {
  url:'visualaidmaster/e-detailing/<%= divisionId %>/<%= fromDate %>/<%= toDate %>?brandId=<%= brandId %>&specialityId=<%= specialityId %>&classificationId=<%= classificationId %>&doctorName=<%= doctorName %>',
  method:'GET',
  auth:true,
};
